import {createSelector} from 'reselect';

const novelsSelector = (state:any) => state.novels;

export const getNovels = createSelector(
    [novelsSelector],
    state => state.list
);